export default __webpack_public_path__ + "static/media/autocrm.05e1ea52.svg";